if (!customElements.get('local-video')) {
  class LocalVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.video = this.querySelector('video');

      if (!this.button || !this.video) return;

      this.button.addEventListener('click', () => {
        this.video.play();

        this.button.classList.add('hidden');

        setTimeout(() => {
          this.button.classList.remove('hidden');
        }, this.video.duration * 1000);
      });
    }
  }

  customElements.define('local-video', LocalVideo);
}
